import { isAuthError } from '../../companion-client/AuthError.js';
import { describeCompanionError } from '../../companion-client/errorCodes.js';
import { isAbortError, toError } from '../../utils/index.js';
const handleError = (uppy) => (err) => {
    // authError just means we're not authenticated, don't report it
    if (isAuthError(err)) {
        return;
    }
    const error = toError(err);
    // AbortError means the user has clicked "cancel" on an operation
    if (isAbortError(error)) {
        uppy.log('Aborting request', 'warning');
        return;
    }
    uppy.log(error, 'error');
    if (error.name === 'UserFacingApiError') {
        uppy.info({
            message: uppy.i18n('companionError'),
            details: describeCompanionError(uppy.i18n, error),
        }, 'warning', 5000);
    }
};
export default handleError;
